"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonHelpers = void 0;
var React = require("react");
var moment = require("moment");
var CommonHelpers = /** @class */ (function () {
    function CommonHelpers() {
    }
    CommonHelpers.booleanToText = function (value, trueValue, falseValue) {
        var valueToConvert = typeof value === 'string' ? JSON.parse(value) : value;
        return valueToConvert ? trueValue : falseValue;
    };
    CommonHelpers.getPrintableDocuments = function (allDocuments, nonPrintableDocuments) {
        return allDocuments.filter(function (doc) { return !nonPrintableDocuments.some(function (nonPrintDoc) { return doc.name.includes(nonPrintDoc); }); });
    };
    CommonHelpers.setSessionStorage = function (key, value) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    };
    CommonHelpers.getSessionStorage = function (key) {
        var object = window.sessionStorage.getItem(key);
        if (object) {
            return JSON.parse(object);
        }
        else {
            return null;
        }
    };
    CommonHelpers.getRemovedAndAddedDrivers = function (currentDrivers) {
        var added = [];
        var removed = [];
        var initialDriversList = CommonHelpers.getSessionStorage("initialAdditionalDrivers");
        if (currentDrivers && initialDriversList) {
            var initialDriverSet_1 = new Set(initialDriversList.map(function (driver) { return driver.personId; }));
            var currentDriverSet_1 = new Set(currentDrivers.map(function (driver) { return driver.personId; }));
            currentDrivers.forEach(function (driver, index) {
                if (!initialDriverSet_1.has(driver.personId)) {
                    added.push(React.createElement("span", null,
                        driver.firstName,
                        " ",
                        driver.lastName,
                        index < currentDrivers.length - 1 ? ', ' : ''));
                }
            });
            initialDriversList.forEach(function (driver, index) {
                if (!currentDriverSet_1.has(driver.personId)) {
                    removed.push(React.createElement("span", null,
                        driver.firstName,
                        " ",
                        driver.lastName,
                        index < initialDriversList.length - 1 ? ', ' : ''));
                }
            });
        }
        return { addedDrivers: added, removedDrivers: removed };
    };
    CommonHelpers.getAmountWithDecimalDigits = function (amount) {
        var fixedAmount = 1 * amount;
        return new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(fixedAmount);
    };
    CommonHelpers.getAmountToDisplay = function (amount) {
        if ((amount % 1) === 0) {
            return "£" + new Intl.NumberFormat('en-UK').format(amount);
        }
        else {
            return this.getAmountWithDecimalDigits(amount);
        }
    };
    CommonHelpers.getPolicyHolderFullName = function (interaction) {
        return interaction.policyHolder.firstName + " " + interaction.policyHolder.lastName;
    };
    CommonHelpers.getDate = function (environmentVariable) {
        var date = moment(environmentVariable);
        if (!date.isValid()) {
            throw new Error("Invalid date format. Expected YYYY-MM-DD: " + environmentVariable);
        }
        return date.toDate();
    };
    return CommonHelpers;
}());
exports.CommonHelpers = CommonHelpers;
//# sourceMappingURL=CommonHelpers.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/helpers/CommonHelpers.js
// module id = 2486
// module chunks = 0